import { reactive } from 'vue'

const theme = reactive({
  agentLogo: '',
  devLogo: 'logo.png',
  apiUrl: 'https://api.metaluxe.com.au/',
  bunnyApiUrl: 'https://api.bunny.net/',

  videoLibraryId: '479853',
  streamCdnUrl: 'https://vz-71edd7f3-d7b.b-cdn.net',
  streamApiKey: '1a13d82a-0643-490f-accee8428467-23bd-40db',

  storageApiPassword: '14b8bab6-3b45-408e-86d33f5cf231-c484-4b55',
  cdnUrl: 'https://panorama-pwa.b-cdn.net',
  devFolder: '/panorama-pwa',

  CinematicsIcon: '/img/ui-theme/videos-icon.svg',
  rendersIcon: '/img/ui-theme/renders-icon.svg',
  rangeIcon: '/img/ui-theme/range-icon.svg',
  panoramasIcon: '/img/ui-theme/panoramas-icon.svg',
  '360-ToursIcon': '/img/ui-theme/panoramas-icon.svg',

  dashboardMp4: '/theme/dashboard/background-video.mp4',

  // top level menu
  assetsMenuOrder: ['Cinematics', '360-Tours'],

  orderAssetsMenu: ['Sky-Home', 'Amenities', 'Exterior-building'],

  panoramaAsset: {
    panoramas: [0],
    panoramasName: ['Panorama'],
    panoramasUrl: [''],
    balconyViews: [0],
    balconyViewsName: ['Panorama'],
    balconyViewsUrl: [''],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
  },
  skyHomeAsset: {
    balconyViews: [0],
    balconyViewsName: ['Panorama'],
    balconyViewsUrl: [''],
  },
  TypeJAsset: {
    balconyViews: [0],
    balconyViewsName: ['Panorama'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/108/'],
  },
  AmenitiesAsset: {
    balconyViews: [0],
    balconyViewsName: ['Panorama'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/161/'],
  },
})

export default { theme }
